(function ($) {
    'use strict';

    /**
     * JQuery function to serialize a form to JSON object
     * @return {object}
     */
    $.fn.serializeJSON = function () {
        var json = {};
        $.map($(this).serializeArray(), function (n) {
            json[n.name] = n.value;
        });
        return json;
    };

}(jQuery));
